/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GetMultipleProofsRequest model module.
 * @module model/GetMultipleProofsRequest
 * @version V1
 */
class GetMultipleProofsRequest {
    /**
     * Constructs a new <code>GetMultipleProofsRequest</code>.
     * @alias module:model/GetMultipleProofsRequest
     */
    constructor() { 
        
        GetMultipleProofsRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GetMultipleProofsRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetMultipleProofsRequest} obj Optional instance to populate.
     * @return {module:model/GetMultipleProofsRequest} The populated <code>GetMultipleProofsRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetMultipleProofsRequest();

            if (data.hasOwnProperty('proofIds')) {
                obj['proofIds'] = ApiClient.convertToType(data['proofIds'], ['Number']);
            }
            if (data.hasOwnProperty('loadAllData')) {
                obj['loadAllData'] = ApiClient.convertToType(data['loadAllData'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GetMultipleProofsRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GetMultipleProofsRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['proofIds'])) {
            throw new Error("Expected the field `proofIds` to be an array in the JSON data but got " + data['proofIds']);
        }

        return true;
    }


}



/**
 * @member {Array.<Number>} proofIds
 */
GetMultipleProofsRequest.prototype['proofIds'] = undefined;

/**
 * @member {Boolean} loadAllData
 */
GetMultipleProofsRequest.prototype['loadAllData'] = undefined;






export default GetMultipleProofsRequest;

